/* eslint-disable */
import { sanitize } from '@hotmart/devsec-toolkit';

import upsellIcon from './upsell.svg';
window.loadUpsellDropdown = function (options, data) {
  $.Redactor.prototype.upsell = function () {
    return {
      init: function () {
        if (data != null) {
          this.upsell.render(data);
        }
      },
      click: function (data) {
        var id = parseInt(data.substring(1));

        var imgTag =
          "<img src='" +
          options.placeholder +
          "' id='upsell_" +
          id +
          "' style='display: block;' />";
        this.insert.htmlWithoutClean(imgTag);
      },
      render: function (data) {
        var dropdown = {},
          dropdownHeaders = Object.keys(data),
          buttonOptions = {
            hasLabel: true,
            align: 'right',
            icon: upsellIcon
          },
          self = this;

        dropdownHeaders.forEach(function (module, i) {
          dropdown[i] = { items: {} };
          dropdown[i].title = module;

          var pages = data[module];

          pages.forEach(function (page) {
            if (!page.title) {
              page.title = sanitize({
                html: page.pageName
              });
            }
            page.func = self.upsell.click;
            dropdown[i].items['s' + page.id] = page;
          });
        });

        if (Object.keys(dropdown).length) {
          var button = this.button.add('upsell', options.text, buttonOptions);
          this.button.addDropdownWithHeader(button, dropdown);
        }
      }
    };
  };
};
